/**
 * The bridge from the web registry's `bucketsOf` to the shared one (closes open question 215).
 *
 * `bucketsOf` answers "which values does this cell match", and three surfaces need the same
 * answer: `any_of` filtering, the quick-filter facets (B4 §5.4) and group-by (§8.8). It lived
 * in the **web** registry through round 3 only because `boardView.facets` had no endpoint;
 * now the api answers that endpoint and needs the same buckets, so the definition moved down
 * to `packages/shared/src/columns/<type>` and this adapts the one difference between the two
 * callers: the web has a people directory and can turn a person id into a name, the shared
 * definition only promises the **id**, which is what a filter compares `[cvs§4.7]`.
 */
import { findColumnType, type BucketContext } from '@elizmonday/shared';
import type { CellBucket, CellRenderContext } from './types';

/** `bucketsOf` for a type, reading the shared definition and lending it the people directory. */
export function sharedBuckets(type: string) {
  return (value: unknown, settings: unknown, context: CellRenderContext): CellBucket[] => {
    const definition = findColumnType(type);
    if (!definition?.bucketsOf) return [];
    const ctx: BucketContext = {
      nameOf: (id) => context.people.find((person) => String(person.id) === String(id))?.name,
    };
    return [...definition.bucketsOf(value, settings, ctx)];
  };
}
